import PropTypes from 'prop-types';

export default {
  getPrepayTerms: PropTypes.func,
  classNames: PropTypes.string,
  prepayTerms: PropTypes.string,
  showPrintButton: PropTypes.bool,
};
